import PropTypes from "prop-types";

export default PropTypes.shape({
  qualified_goods: PropTypes.arrayOf(
    PropTypes.shape({ part_number: PropTypes.string, qualification_preference: PropTypes.string, id: PropTypes.string, ushts: PropTypes.string }),
  ),
  certificate_id: PropTypes.string,
  created_at: PropTypes.string,
});
